module.exports = __webpack_public_path__ + "static/media/transferencias.93642a32.svg";